import { msAPI } from "./index.js";

export const getTaxRules = async (params = {}) => {
  return (await msAPI.get("merchant/tax/rules", { params })).data;
};

export const createTaxRule = async (data) => {
  return (await msAPI.post("merchant/tax/rules", data)).data;
};

export const updateTaxRule = async (id, data) => {
  return (await msAPI.put(`merchant/tax/rules/${id}`, data)).data;
};

export const deleteTaxRule = async (id) => {
  return (await msAPI.delete(`merchant/tax/rules/${id}`)).data;
};

// State Compliance endpoints
export const getComplianceStates = async (params = {}) => {
  return (await msAPI.get("merchant/compliance/states", { params })).data;
};

export const updateComplianceState = async (code, data) => {
  return (await msAPI.put(`merchant/compliance/states/${code}`, data)).data;
};

export const getComplianceStateProducts = async (code, params = {}) => {
  return (await msAPI.get(`merchant/compliance/states/${code}/products`, { params })).data;
};

export const whitelistProduct = async (code, skuId) => {
  return (await msAPI.post(`merchant/compliance/states/${code}/products/${skuId}`)).data;
};

export const removeWhitelistedProduct = async (code, skuId) => {
  return (await msAPI.delete(`merchant/compliance/states/${code}/products/${skuId}`)).data;
};

export const getStateCategoryRestrictions = async (code) => {
  return (await msAPI.get(`merchant/compliance/states/${code}/categories`)).data;
};

export const updateStateCategoryRestrictions = async (code, categories) => {
  return (await msAPI.patch(`merchant/compliance/states/${code}/categories`, { categories })).data;
};
